import { api } from '@/services'

export const fetchMission = (missionId) => {
  return api.get(`admin/mission/${missionId}`)
}

export const fetchMissions = (params) => {
    return api.get('admin/mission/list', { params })
}

export const save = (params) => {
    return api.post('admin/mission/create', params)
}

export const update = (params) => {
    return api.put('admin/mission/update', params)
}

export const getMissionProgress = (params) => {
    return api.get('admin/mission/missionProgress/', { params })
}

export const pay = (params) => {
    return api.post('admin/mission/pay', params)
}

